/**
 * LanguageToggle — small button to switch between Persian and English.
 */

import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

import { useLanguage } from '@/hooks/useLanguage';

export function LanguageToggle() {
  const { t } = useTranslation();
  const { language, toggle } = useLanguage();

  return (
    <Button
      onClick={toggle}
      startIcon={<LanguageIcon />}
      variant="outlined"
      color="inherit"
      size="small"
      aria-label={t('language.switch')}
    >
      {language === 'fa' ? t('language.english') : t('language.persian')}
    </Button>
  );
}

export default LanguageToggle;
